/* eslint-disable max-len */
import React from 'react';

const VKButtonIcon: React.FC<object> = () => {

    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 15.36C0 8.12121 0 4.50182 2.25091 2.25091C4.50182 0 8.12121 0 15.36 0H16.64C23.8788 0 27.4982 0 29.7491 2.25091C32 4.50182 32 8.12121 32 15.36V16.64C32 23.8788 32 27.4982 29.7491 29.7491C27.4982 32 23.8788 32 16.64 32H15.36C8.12121 32 4.50182 32 2.25091 29.7491C0 27.4982 0 23.8788 0 16.64V15.36Z" fill="#0077FF"/>
            <path d="M17.0347 23.0507C9.74669 23.0507 5.59016 18.0533 5.41675 9.73334H9.06742C9.18742 15.8907 11.9047 18.5013 14.056 19.0347V9.73334H17.4934V14.9867C19.6181 14.7574 21.8493 12.336 22.6027 9.73334H26.04C25.4614 12.9413 23.04 15.3627 21.32 16.3573C23.04 17.1627 25.7974 19.2747 26.84 23.0507H23.056C22.24 20.5067 20.2 18.5413 17.4934 18.2693V23.0507H17.0347Z" fill="white"/>
        </svg>
    );
};

export default VKButtonIcon;
